import type { AxiosError } from "axios"
import { CookieKey } from "@/configs/common"
import { cookieStorage } from "wagmi"
import { toast } from "sonner"

interface TokenExpiredResponse {
  message?: string
  error?: string
  statusCode?: number
}

function isTokenExpiredResponse(data: unknown): data is TokenExpiredResponse {
  if (!data || typeof data !== "object") return false
  const d = data as Record<string, unknown>
  return (
    d.message === "token_expired" &&
    d.error === "Unauthorized" &&
    d.statusCode === 401
  )
}

export function handleUnauthorizedResponse(error: AxiosError): void {
  const status = error.response?.status
  const data = error.response?.data

  if (status === 401 && isTokenExpiredResponse(data)) {
    cookieStorage.removeItem(CookieKey.AuthToken)
    toast.error("Session expired. Please sign in again.")
  }
}
